import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formModal: {
    display: "flex",
    alignItems: "center",
  },
  formModalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingRight: "0.938rem",
  },
  formModalTitle: {
    fontSize: "1.8rem",
    lineHeight: "1.5rem",
    padding: "0rem 1.875rem",
    fontWeight: "bold",
  },
  formModalBody: {
    padding: "1rem 1.875rem 1.875rem",
    borderTop: "1px solid rgba(153,153,153,.5)",
  },
  formModalBodyNoTopBorder: {
    padding: "1rem 1.875rem 1.875rem",
  },
  formModalWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "auto",
    width: "100vw",
    height: "100vh",
  },
  formModalContainer: {
    border: "2px solid #000",
    backgroundColor: "#FFF",
    width: "100%",
    maxWidth: "50rem",
    maxHeight: "100vh",
    overflow: "auto",
  },
  formModalWithNoBorders: {
    border: "none"
  },
  formModalFooter: {
    padding: "0.625rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },
  formModalButton: {
    background: "#658D1B",
    border: 0,
    borderRadius: 1,
    color: "white",
    marginLeft: 3,
    width: "6.25rem",
    marginRight: "0.625rem",
    alignItems: "center",
    justifyContent: "center",
    height: "2.375rem",
  },
}));

export default useStyles;
